import { Box } from "@mui/material";
import { Sidebar, TitlePortal, useSidebarState } from "react-admin";
import { CustomAppBar } from "../custombar";
import { CustomMenu } from "../custommenu";
import {
  APP_BAR_HEIGHT,
  COLLAPSED_WIDTH,
  SIDEBAR_WIDTH,
} from "@/constants/resources";

export const CustomLayout = ({ children }: { children: React.ReactNode }) => {
  const [open] = useSidebarState();
  return (
    <Box sx={{ height: "100vh", overflow: "hidden" }}>
      {/* Sidebar fixed full height */}
      <Box
        sx={{
          width: open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH,
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bgcolor: "#fff",
          borderRight: "1px solid #ddd",
          zIndex: 1200,
        }}
      >
        <Sidebar
          sx={{
            width: open ? SIDEBAR_WIDTH : COLLAPSED_WIDTH,
            backgroundColor: "#fff",
            color: "text.primary",
            height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
            mt: 1,
            overflowX: "auto",
            position: "fixed",
            top: 0,
            left: 0,
            borderRight: "1px solid #ddd",
            transition: "width 0.3s ease",
            pt: 0,
          }}
        >
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: open ? "center" : COLLAPSED_WIDTH,
                px: 2,
                py: 2,
                gap: 1,
              }}
            >
              <img
                src="/logo-gameoo.png"
                alt="Logo"
                style={{
                  width: open ? "auto" : COLLAPSED_WIDTH,
                  height: open ? 40 : 30,
                  transition: "width 0.3s",
                }}
              />
            </Box>

            {/* Menu */}
            <CustomMenu />
          </>
        </Sidebar>
      </Box>

      {/* AppBar pushed right by sidebar */}
      <Box
        sx={{
          position: "fixed",
          left: open ? `${SIDEBAR_WIDTH}px` : `${COLLAPSED_WIDTH}px`,
          top: 0,
          right: 0,
          height: `${APP_BAR_HEIGHT}px`,
          zIndex: 1300,
          transition: "left 0.3s ease",
        }}
      >
        <CustomAppBar />
      </Box>

      {/* Main content pushed right and down */}
      <Box
        component="main"
        sx={{
          position: "absolute",
          top: APP_BAR_HEIGHT,
          left: open ? `${SIDEBAR_WIDTH}px` : `${COLLAPSED_WIDTH}px`,
          right: 0,
          bottom: 0,
          overflowY: "auto",
          p: 3,
        }}
      >
        <TitlePortal variant="h4" component="h4" />
        {children}
      </Box>
    </Box>
  );
};
